module.exports = __webpack_public_path__ + "img/1.d9a072b2.png";